export const NotificationMailingEnum = {
    IMMEDIATE: 'IMMEDIATE',
    MODERATE: 'MODERATE',
    OFF: 'OFF',
};

export default NotificationMailingEnum;
